// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M11.9 8L14.5 8M10.76 10.76L12.6 12.6M8 11.9L8 14.5M5.24 10.76L3.4 12.6M4.1 8L1.5 8M5.24 5.24L3.4 3.4M8 4.1L8 1.5M10.76 5.24L12.6 3.4',
];
